import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["id", "data-content-piece"]
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = {
  key: 1,
  class: "card-body"
}
const _hoisted_5 = {
  key: 0,
  class: "card-body__price"
}
const _hoisted_6 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_card_image_top = _resolveComponent("card-image-top")!

  return (_openBlock(), _createElementBlock("a", {
    id: `segment-${_ctx.segment.alias}`,
    class: _normalizeClass([{'card--selected': _ctx.segment.chosen}, "card card--path-segment"]),
    "data-content-piece": `${_ctx.decodeHtml(_ctx.segment.title)}`,
    "data-content-name": "Bestattungskonfigurator",
    "data-track-content": "",
    href: "#",
    title: "Auswählen",
    onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args)), ["prevent"]))
  }, [
    (_ctx.segment.icon || _ctx.segment.image)
      ? (_openBlock(), _createBlock(_component_card_image_top, {
          key: 0,
          icon: _ctx.segment.icon,
          image: _ctx.segment.image
        }, null, 8, ["icon", "image"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", {
        class: "card-title",
        innerHTML: _ctx.decodeHtml(_ctx.segment.title)
      }, null, 8, _hoisted_3)
    ]),
    (_ctx.segment.description || _ctx.segment.showPrice)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_ctx.segment.showPrice)
            ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.segmentPriceForDisplay), 1))
            : _createCommentVNode("", true),
          (_ctx.segment.description)
            ? (_openBlock(), _createElementBlock("p", {
                key: 1,
                innerHTML: _ctx.decodeHtml(_ctx.segment.description)
              }, null, 8, _hoisted_6))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}